<template>
    <div id="vMenu">
        <div class="list-group list-group-flush panel">
            <b-list-group-item
                :href="menuRoutes['dashboardAccountingFirmWeekChargeControl']"
                class="item"
                :active="
                    pageName === 'accountingFirmTimeSheetWeekChargeControl'
                "
                data-parent="#vMenu"
                @click="setPageName('accountingFirmTimeSheetWeekChargeControl')"
            >
                <i class="fa-fw fal fa-calendar-check menu-icon"></i>
                Contrôle saisie hebdo
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['dashboardAccountingFirmUserChargeControl']"
                class="item"
                :active="
                    pageName === 'accountingFirmUserTimeSheetChargeControl'
                "
                data-parent="#vMenu"
                @click="setPageName('accountingFirmUserTimeSheetChargeControl')"
            >
                <i class="fa-fw fal fa-calendar-check menu-icon"></i>
                Contrôle saisie collaborateur
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['dashboardAccountingFirmUserWeekReport']"
                class="item"
                :active="pageName === 'accountingFirmUserTimeSheetWeekReport'"
                data-parent="#vMenu"
                @click="setPageName('accountingFirmUserTimeSheetWeekReport')"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse hebdo collaborateur
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['dashboardAccountingFirmUserYearReport']"
                class="item"
                :active="pageName === 'accountingFirmUserTimeSheetYearReport'"
                data-parent="#vMenu"
                @click="setPageName('accountingFirmUserTimeSheetYearReport')"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse annuelle collaborateur
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['dashboardClientYearReport']"
                class="item"
                :active="pageName === 'clientTimeSheetYearReport'"
                data-parent="#vMenu"
                @click="setPageName('clientTimeSheetYearReport')"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                Synthèse annuelle client
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['dashboardPivotReport']"
                class="item"
                :active="pageName === 'pivotTimeSheetReport'"
                data-parent="#vMenu"
                @click="setPageName('pivotTimeSheetReport')"
            >
                <i class="fa-fw fal fa-table menu-icon"></i>
                TCD client
            </b-list-group-item>

            <b-list-group-item href="#" class="item">
                <b-row>
                    <b-col sm="7" class="pt-1">
                        <i class="fa-fw fal fa-file-excel menu-icon"></i>
                        Export Excel
                    </b-col>
                    <b-col sm="5">
                        <b-form-select
                            v-model="exportYear"
                            :options="yearOptions"
                            class="text-dark"
                            size="sm"
                            @change="excelExport"
                            ><template #first>
                                <b-form-select-option :value="null" disabled>
                                    -- Année --
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TimeSheetsDashboardVerticalMenu',

    data() {
        return {
            exportYear: null,
            yearOptions: [],
        }
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.timeSheetsVM.showVerticalMenu,
            menuRoutes: (state) => state.timeSheetsVM.menuRoutes,
            isAdmin: (state) => state.timeSheetsVM.isAdmin,
        }),

        currentYear() {
            return new Date().getFullYear()
        },
    },

    async created() {
        await this.$store.dispatch('timeSheetsVM/getRoutes')
        this.$store.commit('timeSheetsVM/SHOW_VERTICAL_MENU')
        this.setYearOptions()
    },

    mounted() {
        this.$store.commit(
            'timeSheetsVM/SET_VIEW_ALL_TIME_SHEETS',
            this.menuRoutes.viewAllTimeSheets
        )
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },

        setYearOptions() {
            this.yearOptions = [
                { text: this.currentYear, value: this.currentYear },
                {
                    text: (this.currentYear - 1).toString(),
                    value: this.currentYear - 1,
                },
                {
                    text: (this.currentYear - 2).toString(),
                    value: this.currentYear - 2,
                },
                {
                    text: (this.currentYear - 3).toString(),
                    value: this.currentYear - 3,
                },
            ]
        },

        excelExport() {
            window.location = `${this.menuRoutes.export}/${this.exportYear}`
        },
    },
}
</script>

<style scoped></style>
